import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { authAPI } from "../services/api";
import FilledButton from "../components/FilledButton";
import { Email, Lock, Person } from "@mui/icons-material";
import toast from "react-hot-toast";

export default function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return;
    }

    setLoading(true);

    try {
      const response = await authAPI.signup(email, password, name);
      localStorage.setItem("token", response.access_token);
      toast.success("Account created successfully!");
      navigate("/dashboard");
    } catch (error) {
      // Handle different types of errors
      let errorMessage = "Signup failed. Please try again.";
      
      if (error.response) {
        // Server responded with error status
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        // Request was made but no response received
        errorMessage = "Network error. Please check your connection.";
      } else {
        // Something else happened
        errorMessage = error.message || errorMessage;
      }
      
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md border border-borderLight">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-primaryGreen mb-2">
            Create Account
          </h1>
          <p className="text-primaryGray">Sign up to manage licenses</p>
        </div>

        <form onSubmit={handleSignup} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-primaryText mb-2">
              Name (Optional)
            </label>
            <div className="relative">
              <Person className="absolute left-3 top-1/2 transform -translate-y-1/2 text-essentialGray w-5 h-5" />
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-borderLight rounded-lg focus:outline-none focus:ring-2 focus:ring-primaryGreen focus:border-transparent"
                placeholder="Enter your name"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-primaryText mb-2">
              Email *
            </label>
            <div className="relative">
              <Email className="absolute left-3 top-1/2 transform -translate-y-1/2 text-essentialGray w-5 h-5" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-borderLight rounded-lg focus:outline-none focus:ring-2 focus:ring-primaryGreen focus:border-transparent"
                placeholder="Enter your email"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-primaryText mb-2">
              Password *
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-essentialGray w-5 h-5" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-borderLight rounded-lg focus:outline-none focus:ring-2 focus:ring-primaryGreen focus:border-transparent"
                placeholder="Enter your password (min. 6 characters)"
                required
                minLength={6}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-primaryText mb-2">
              Confirm Password *
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-essentialGray w-5 h-5" />
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-borderLight rounded-lg focus:outline-none focus:ring-2 focus:ring-primaryGreen focus:border-transparent"
                placeholder="Confirm your password"
                required
                minLength={6}
              />
            </div>
          </div>

          <FilledButton
            text="Sign Up"
            btnType="submit"
            showLoader={loading}
            isDisabled={loading}
            width="full"
          />

          <div className="text-center text-sm text-primaryGray">
            Already have an account?{" "}
            <Link
              to="/login"
              className="text-primaryGreen hover:text-primaryGreenHover font-medium"
            >
              Sign in
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

